import { useContext } from "react"

// ** Gatsby
import { GatsbyImage } from "gatsby-plugin-image"

// ** Custom Components
import Box from "../Box"
import Text from "../Text"
import PageContext from "../../contexts/PageContext"

interface StaffCardProps {
  staff: any
}
const StaffCard = ({ staff }: StaffCardProps) => {
  const page = useContext(PageContext)

  return (
    <Box className="relative overflow-hidden w-[280px] h-[440px] rounded-xl isolate shadow-lg mt-12 lg:mt-24">
      <Box className="absolute z-0 h-full w-full">
        <GatsbyImage
          className="h-full w-full"
          image={staff.photo?.asset?.gatsbyImageData}
          alt={staff.firstname + staff.lastname}
          objectFit="cover"
        />
      </Box>
      <Box className="text-center absolute bottom-0 inset-x-0 bg-white px-6 py-3 z-10 h-[130px]">
        <Text variant="body-copy" className="text-blue-500 font-bold">
          {staff.firstname} {staff.lastname}
        </Text>
        <Text variant="body-copy" className="text-gray-700">
          {staff.title[page.i18n_lang]}
        </Text>
      </Box>
    </Box>
  )
}

export default StaffCard
